import React from 'react'

const CopyRight = () => {
  return (
    <div>
        <div className='py-2' style={{ backgroundColor:'#2076ad'}}>
            <div className='fs-ss-14 text-open-sauce-one fw-400 text-white mb-2' style={{ letterSpacing:'0.5px'}}>
                <center>
                    Copyright @ 2023 United Lab Care. All rights reserved | Powered by<a href='https://simplesolutionz.org/' target='_blank' rel='noreferrer' className='text-white' style={{ textDecoration:'none'}}> Simple Solutionz</a>
                </center>
            </div>
            <div className='fs-ss-12 text-open-sauce-one fw-400 text-white mb2' style={{ letterSpacing:'0px'}}>
                <center>
                    Disclaimer: Please note that the information provided is not for any medical use. Refer to your local government and/or health organisations for the most accurate and up to date information.
                </center>
            </div>
        </div>
    </div>
  )
}

export default CopyRight